import { getUserToken } from "src/utils/jwtToken";
import { useActingAsOverrideHeader } from "../auth";
import { useTokenRefreshHandler } from "../hooks";
import { useUserService } from "../services";
import { errorHandler } from "src/hooks/errorHandler";

export interface ValidateBeginFollowUpRequest {
  eventId: number;
  contactIds?: number[]; // Optional - if not provided, will validate all guests with assigned templates
}

export interface ValidateBeginFollowUpResponse {
  reasons: string[];
  canBegin: boolean;
}

export function useValidateBeginFollowUp() {
  const accessToken = getUserToken();
  const service = useUserService();
  const tokenRefreshHandler = useTokenRefreshHandler();
  const override = useActingAsOverrideHeader();

  const headers: { [index: string]: string } = {
    "JWT-TOKEN": accessToken as string,
  };

  if (override) {
    headers.override = override;
  }

  return async (
    request: ValidateBeginFollowUpRequest,
  ): Promise<ValidateBeginFollowUpResponse> => {
    try {
      const response = await service
        .post(`/api/webinars/${request.eventId}/follow-up/validate-begin`)
        .set(headers)
        .send({
          contactIds: request.contactIds,
        })
        .then(tokenRefreshHandler)
        .then((res: Response) => res.body);

      return response;
    } catch (error) {
      throw errorHandler(error as any);
    }
  };
}

export default useValidateBeginFollowUp;
